import { BreadcrumbEvent } from 'types/analytics/breadcrumb/breadcrumb.enum';
import type { IBreadcrumbInteraction } from 'types/analytics/breadcrumb/breadcrumb.types';
import trackEvent from 'event-tracks';

const trackBreadcrumbInteraction = (eventData: IBreadcrumbInteraction): void =>
  trackEvent(BreadcrumbEvent.BreadcrumbInteraction, eventData);

export default trackBreadcrumbInteraction;
